import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lock, Search, UserCheck } from "lucide-react";
import { Avatar } from "@/components/Avatar";
import { api } from "@/lib/api";

export function TravelerSearch() {
  const [q, setQ] = useState("");
  const [results, setResults] = useState(null);
  useEffect(() => {
    if (q.trim().length < 2) { setResults(null); return undefined; }
    let live = true;
    const t = setTimeout(() => api.get("/travelers/search", { params: { q: q.trim() } })
      .then((r) => live && setResults(r.data)).catch(() => live && setResults([])), 300);
    return () => { live = false; clearTimeout(t); };
  }, [q]);

  return (
    <div className="mt-6">
      <div className="flex items-center gap-2 rounded-2xl bg-[#151C2C] border border-[#26334D] focus-within:border-[#FFB800] px-4 py-2.5 transition-colors">
        <Search className="h-4 w-4 text-[#FFB800]" />
        <input data-testid="traveler-search-input" value={q} onChange={(e) => setQ(e.target.value)} maxLength={40}
          placeholder="Find friends & family by name…" className="flex-1 bg-transparent outline-none text-sm placeholder:text-slate-500" />
      </div>
      {results && (
        <div data-testid="traveler-search-results" className="mt-3 space-y-2">
          {results.length === 0 && <p data-testid="traveler-search-empty" className="text-sm text-slate-500 px-1">No travelers found.</p>}
          {results.map((t) => (
            <Link key={t.id} to={`/traveler/${t.id}`} data-testid={`traveler-result-${t.id}`}
              className="flex items-center gap-3 rounded-2xl bg-[#151C2C] border border-[#26334D] hover:border-[#FFB800] p-3 transition-colors">
              <Avatar url={t.avatar_url} name={t.name} size="h-9 w-9" />
              <span className="font-semibold text-sm flex-1">{t.name}</span>
              {t.private && <Lock className="h-3.5 w-3.5 text-slate-500" />}
              {t.is_following && <span className="text-xs text-[#00E5A3] flex items-center gap-1"><UserCheck className="h-3.5 w-3.5" /> Following</span>}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
